import { render, staticRenderFns } from "./SurveyBanner.vue?vue&type=template&id=7223aacb"
import script from "./SurveyBanner.vue?vue&type=script&lang=js"
export * from "./SurveyBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports